import React from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "components/Graphs/Button";
import { cn } from "lib/utils";

interface EnvironmentRefreshButtonProps {
  isRefreshing: boolean;
  onRefresh: () => Promise<unknown> | void;
  className?: string;
}

const EnvironmentRefreshButton: React.FC<EnvironmentRefreshButtonProps> = ({
  isRefreshing,
  onRefresh,
  className,
}) => (
  <Button
    type="button"
    variant="secondary"
    onClick={() => void onRefresh()}
    disabled={isRefreshing}
    aria-busy={isRefreshing || undefined}
    className={cn("gap-2", className)}
  >
    <RefreshCw
      aria-hidden="true"
      className={cn("h-4 w-4", isRefreshing && "animate-spin")}
    />
    {isRefreshing ? "Refreshing…" : "Refresh"}
  </Button>
);

export default EnvironmentRefreshButton;
